<template>
    <div class="appdetail">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn('Update')">
                            <font>保存</font>
                        </el-button>
                        <el-button type="success" class="btn-" size="mini" @click="saveBtn('Submit')" v-show="addtitle">保存并继续</el-button>
                    </div>
                </div>
            </div>
            <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
          <el-tab-pane label="列表" name="列表">
          </el-tab-pane>
          <el-tab-pane label="详情" name="详情">
            <div class="appdetail-content" :style="{height: 'calc(100vh - 205px)'}">
          <el-form inline-message :model="CATEGORY" :rules="rules" ref="CATEGORY" label-width="100px" class="demo-adduserForm">
            <div class="content-accordion" id="information">
              <el-collapse v-model="activeNames">
                <el-collapse-item title="按钮配置" name="1">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="标准功能?" prop="sort">
                        <el-switch v-model="CATEGORY.isstandard"  active-value="1" inactive-value="0"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="按钮名称" prop="name">
                        <el-input v-model="CATEGORY.name"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="CATEGORY.isstandard!='1'">
                      <el-form-item label="所属菜单" prop="menucode">
                        <!-- <el-input v-model="CATEGORY.menucode"></el-input> -->
                        <el-select v-model="CATEGORY.menucode" filterable style="width: 100%">
                          <el-option v-for="item in selectDataMenu" :key="item.id" :value="item.code" :label="item.name" :class="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="按钮图标" prop="icon">
                        <el-input v-model="CATEGORY.icon" :disabled="edit">
                          <i :class="CATEGORY.icon" slot="prepend"></i>
                          <el-button slot="append" icon="el-icon-search" @click="getIcon"></el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="按钮颜色" prop="style">
                        <el-select v-model="CATEGORY.style" style="width: 100%">
                          <el-option v-for="item in selectData" :key="item.id" :value="item.name" :label="item.name" :class="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="排序" prop="sort">
                        <el-input v-model="CATEGORY.sort"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="事件" prop="eventmethod">
                        <el-input v-model="CATEGORY.eventmethod"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="16" v-if="CATEGORY.isstandard !=='1'">
                      <el-form-item label="请求接口" prop="requestinterfaceurl">
                        <el-input v-model="CATEGORY.requestinterfaceurl"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="CATEGORY.isstandard !=='1'">
                      <el-form-item label="请求方式" prop="requestmethod">
                        <el-input v-model="CATEGORY.requestmethod"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="列表页?" prop="isforlisttab">
                        <el-switch v-model="CATEGORY.isforlisttab"  active-value="1" inactive-value="0"></el-switch>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="非列表页?" prop="isforothertab">
                        <el-switch v-model="CATEGORY.isforothertab"  active-value="1" inactive-value="0"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="查询条件" name="2">
                    <div style="position: absolute; top:5px; right:45px;">
                        <el-button type="success" size="mini" @click="addparamList">
                          <i class="icon-add"></i>
                          <font>新建行</font>
                        </el-button>
                      </div>
                      <el-table :fig="true" :header-cell-style="rowClass" row-key="id"  :data="CATEGORY.paramList" border stripe max-height="350" highlight-current-row style="width: 100%;" @cell-click="iconOperation">
                        <el-table-column prop="iconOperation" fixed width="50">
                          <template slot-scope="scope">
                            <div style="width: 50px;">
                              <i class="el-icon-check" v-if="scope.row.isEditing"></i>
                              <i class="el-icon-edit" v-else></i>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="paramname" label="key" sortable>
                          <template slot-scope="scope">
                            <el-form-item>
                              <el-input v-if="scope.row.isEditing" size="small" v-model="scope.row.paramname">
                              </el-input>
                              <span v-else>{{scope.row.paramname}}</span>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column prop="paramvalue" label="value" sortable>
                          <template slot-scope="scope">
                            <el-form-item>
                              <el-input v-if="scope.row.isEditing" size="small" v-model="scope.row.paramvalue">
                              </el-input>
                              <span v-else>{{scope.row.paramvalue}}</span>
                            </el-form-item>
                          </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="120">
                          <template slot-scope="scope">
                            <el-button type="text" size="small" @click="delparamItem(scope.$index,scope.row)">
                              <i class="icon-trash red"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-form>
            </div>
          </el-tab-pane>
      </el-tabs>


    <!--应用中心图标弹出 Begin-->
    <div class="mask" v-show="show2"></div>
    <div class="mask_divbg" v-show="show2">
      <div class="mask_div">
        <div class="mask_title_div clearfix">
          <div class="mask_title">应用中心图标</div>
          <div class="mask_anniu">
            <span class="mask_span mask_max" @click="toggle">
              <i v-bind:class="{ 'icon-maximization': isok1, 'icon-restore':isok2}"></i>
            </span>
            <span class="mask_span" @click='close2'>
              <i class="icon-close1"></i>
            </span>
          </div>
        </div>
        <div class="mask_content" :style="{height: fullHeight}">
          <div class="content-accordion">
            <all_icons v-on:childByValue="childByValue"></all_icons>
          </div>
          <div class="content-footer">
            <el-button type="primary" @click="confirm2();">确 定</el-button>
            <el-button @click='close2'>取 消</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--应用中心图标弹出 End-->
  </div>
</template>

<script>

import all_icons from '../../commonComponents/all_icons.vue'
import ElCol from "element-ui/packages/col/src/col";
//弹出框
export default {
  name: 'masks',
  components: {
    ElCol,
    'all_icons': all_icons,
  },
  data() {
    return {
      currentDetailTabsModel:"详情",
      drawer:false,
      CATEGORY:{},
      loading: false,
      basic_url: Config.dev_url,
      selUser: [],
      edit: true, //禁填
      show: false,
      show2: false,
      isok1: true,
      isok2: false,
      inputVisible: false,
      inputValue: '',
      activeNames: ['1', '2' ,'3'], //手风琴数量
      selectData: [],
      selectDataMenu: [],//所属菜单
      fullHeight: document.documentElement.clientHeight - 200 + 'px',//获取浏览器高度
      rules: {
        name: [{ required: true, trigger: 'change', validator: this.Validators.isSpecificKey, }],
        menucode: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      //tree
      resourceData: [], //数组，我这里是通过接口获取数据
      category: {},//从父组件接过来的值
      addtitle: true,
      dept: false,
    };
  },
  methods: {
    rowClass({ row, rowIndex }) {
      return 'text-align:center'
    },
    iconOperation(row, column, cell, event) {
      console.log(row)
      if (column.property === "iconOperation") {
        row.isEditing = !row.isEditing;
      }
    },
    delparamItem(index,row){
        if (row.id) {
          var url = Config.dev_url + '/api-user/permissions/deleteParam/' + row.id;
          this.$confirm('确定删除此数据吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({value}) => {
            this.$axios.delete(url, {}).then((res) => {
              if (res.data.code == 0) {
                this.CATEGORY.paramList.splice(index, 1);
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
            }).catch((err) => {
          });
        })
      } else {
        this.CATEGORY.paramList.splice(index, 1);
      }
    },
    addparamList(){
        var obj = {
            paramname:'',
            paramvalue:'',
            isEditing:true
        }
        this.CATEGORY.paramList.push(obj)
    },
    // 按钮图标childValue就是子组件传过来的值
    childByValue: function (childValue) {
      this.sendchildValue = childValue;

    },
    //图标
    getIcon() {
      this.show2 = true;
    },
    //按钮图标关闭
    close2() {
      this.show2 = false;
    },
    //按钮图标确定
    confirm2() {
      this.CATEGORY.icon = this.sendchildValue;
      this.show2 = false;
    },

    //添加显示弹窗
    addBtn() {
      this.CATEGORY = {
          id: '',
          name: '',//按钮名称
          menucode: '',//所属菜单
          icon: '',//图标
          style: '',//按钮颜色
          deptid: '',//部门ID
          sort: '',//排序
          permission: '',//按钮事件名称
          creatUser: '',//录入人
          createTime: '',//录入时间
          updateUser: '',//修改人
          updateTime: '',//修改时间
          paramList:[]
      };
      this.currentDetailTabsModel = "详情"
      this.addtitle = true;
      this.dept = false;
      this.isok2 = false;
      this.isok1 = true;
    },
    //这是查看
    view(item) {
      this.currentDetailTabsModel = "详情"
      var url = Config.dev_url + "/api-user/permissions/" + item.code;
      this.$axios
        .get(url, {})
        .then(res => {
          this.CATEGORY = res.data.data;
        })
        .catch(err => { });
      this.getupdateuserdesc()
      this.getcreateuserdesc()
      this.addtitle = false;
      // this.dept = true;
      this.isok2 = false;
      this.isok1 = true;
    },
    //获取按钮颜色
    getBtnColor() {
      var url = Config.dev_url + '/api-user/dicts/findChildsByCode?code=BTNCOLOR';
      this.$axios.get(url, {}).then((res) => {
        this.selectData = res.data;
      }).catch((wrong) => {
      })
    },
    //所属菜单
    getMenucode() {
      var url = Config.dev_url + '/api-user/menus/findAllMenu';
      this.$axios.get(url, {}).then((res) => {
        this.selectDataMenu = res.data;
      }).catch((wrong) => {
      })
    },
    //tab选项卡点击
    tabClick(tab){
        if(tab.label == "列表"){
            this.$store.commit('setcurrentShowPage',1)
            this.$emit("request")
        }else{
            this.$store.commit('setcurrentShowPage',2)
        }
    },
    toggle(e) {
      if (this.isok1 == true) {
        this.maxDialog();
      } else {
        this.rebackDialog();
      }
    },
    maxDialog(e) { //定义大弹出框一个默认大小
      this.isok1 = false;
      this.isok2 = true;
      $(".mask_div").css("width", "100%");
      $(".mask_div").height(document.body.clientHeight - 60);
      $(".mask_div").css("top", "60px");
      $(".mask_divbg").css("top", "0px");
    },
    //还原按钮
    rebackDialog() { //大弹出框还原成默认大小
      this.isok1 = true;
      this.isok2 = false;
      $(".mask_div").css("width", "85%");
      $(".mask_div").css("height", "90%");
      $(".mask_div").css("top", "0px");
      $(".mask_divbg").css("top", "100px");
    },
    // 保存users/saveOrUpdate
    saveBtn(parameter) {
      this.$refs.CATEGORY.validate((valid) => {
        if (valid) {
          if (this.CATEGORY.showtab != undefined) {
            this.CATEGORY.showtab = this.CATEGORY.showtab.join(",");
          }
          this.CATEGORY.STATUS = ((this.CATEGORY.STATUS == "1" || this.CATEGORY.STATUS == '活动') ? '1' : '0');
          var url = Config.dev_url + '/api-user/permissions/saveOrUpdate';
          this.$axios.post(url, this.CATEGORY).then((res) => {
            //resp_code == 0是后台返回的请求成功的信息
            if (res.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
       
              if(parameter == 'Submit'){
                this.CATEGORY = {
                    id: '',
                    name: '',//按钮名称
                    menucode: '',//所属菜单
                    icon: '',//图标
                    style: '',//按钮颜色
                    deptid: '',//部门ID
                    sort: '',//排序
                    permission: '',//按钮事件名称
                    creatUser: '',//录入人
                    createTime: '',//录入时间
                    updateUser: '',//修改人
                    updateTime: '',//修改时间
                    paramList:[]
                };
              }else{
                 this.view(res.data.data)
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
            }
          }).catch((err) => {
          });
        } else {
          this.$message({
            message: '未填写完整，请填写',
            type: 'warning'
          });
        }
      });
    },
    handleClose(tag) {
      this.CATEGORY.showtab.splice(this.CATEGORY.showtab.indexOf(tag), 1);
      this.$forceUpdate();
    },

    //关闭抽屉按钮点击
    closeBtn(){
        this.drawer = false
        this.$emit("requestData")
    },
    //获取创建人描述
    getcreateuserdesc() {
        if (!!this.CATEGORY.createuser) {
            var url = Config.dev_url + '/api-user/users/' + this.CATEGORY.createuser
            this.$axios.get(url).then((res) => {
                this.$set(this.CATEGORY, 'createuserdesc', res.data.nickname)
            }).catch((err) => {
          });
        }
    },
    //获取修改人描述
    getupdateuserdesc() {
        if (!!this.CATEGORY.updateuser) {
            var url = Config.dev_url + '/api-user/users/' + this.CATEGORY.updateuser
            this.$axios.get(url).then((res) => {
                this.$set(this.CATEGORY, 'updateuserdesc', res.data.nickname)
            }).catch((err) => {
          });
        }
    }
  },
  mounted() {
    this.getBtnColor();
    this.getMenucode();
  },
  computed:{
    //当前左侧菜单选中的信息
    currentSelectMenuData(){
        return this.$store.state.currentSelectMenuData
    },
    //当前登录人信息
    currentuser() {
        return this.$store.state.currentuser
    },
  }

}
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
